/**
 * Retourne le détail de l’erreur.
 * @param {object} param0
 * @param {import("../../../types/Api/ApiError").ApiError} param0.error
 * @returns {string}
 */
export default function apiGetErrorDetail({ error }) {
  return error?.body?.errors?.[0]?.detail;
}
